module.exports = __webpack_public_path__ + "media/custom/images/map-0a85415f50d5bf5787ad64bf0a4b449c.svg";